/* Holds the redux store so that non-react modules (e.g. RestTemplate) can read
   it without importing the application entry point, which would create a
   circular dependency. */
let store = null;

export function setStore(newStore) {
    store = newStore;
}

export function getStore() {
    return store;
}
